import React, { useState, useEffect } from 'react'
import { app, database, storage } from '../../../firebaseConfig'
import { addDoc, collection, doc, updateDoc } from 'firebase/firestore'
import { TextField, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, IconButton, Snackbar, Alert } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
function EditRegion({ onClose, open, data, list }) {
    const id = data.id
    const [nom, setNom] = useState(data.nom)
    const [errorData, setErrorData] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const handleSubmit = async (e) => {
        e.preventDefault()
        const regionDocRef = doc(database, 'region', id)
        try {
            const listFilter = list.filter((elem) => {
                return elem.id !=id && elem.nom.toLowerCase() == nom.toLocaleLowerCase()
            })
            if (nom != '' && nom != null) {
                if (listFilter.length == 0) {
                    await updateDoc(regionDocRef, {
                        nom: nom,
                    })
                    onClose()
                } else {
                    setErrorData(true)
                    setErrorMessage(' Region déjà existe à notre base de données!')
                }
            }else{
                setErrorData(true)
                setErrorMessage(' Veuillez remplir les champs obligatoire!')
            }

        } catch (err) {
            setErrorData(true)
            setErrorMessage(' Erreur lors de l\'enregistrement!')
        }
    }
    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorData(false)
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Edit province
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <TextField
                    fullWidth
                    id="outlined-number"
                    label="Nom"
                    value={nom}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={(e) => {
                        setNom(e.target.value)
                    }}
                    style={{ mt: 2 }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
                <Button variant='contained' color='success' onClick={handleSubmit} autoFocus>
                    Enregistrer
                </Button>
            </DialogActions>
            <Snackbar open={errorData} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert
                    onClose={handleCloseAlert}
                    severity="error"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {errorMessage}
                </Alert>
            </Snackbar>
        </Dialog>
    )
}

export default EditRegion